import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-promo-inside.svg";

type PromoInsideIconProps = React.SVGProps<SVGSVGElement>;

export const PromoInsideIcon = (props: PromoInsideIconProps) => (
  <Svg {...props} />
);
